export const companySelector = {
  'CompanySelector.Title': 'Hvem vil du bruke Min Side på vegne av?',
  'CompanySelector.Description':
    'Alle opplysninger som vises og oppdateringer som gjøres, vil gjelde for bedriften du velger. Du kan også bytte bruker ved å trykke på navnet i høyre hjørne.',
};
